import React from "react";
import NewPartContainer from "../containers/NewPartContainer";

export const NewPartPage: React.FunctionComponent = () => <NewPartContainer />;
